<!-- 岗位卡片 -->
<template>
  <div>
    <div
      class="bg-white rounded py-[20px] px-[24px] mb-[20px] flex justify-between hover:shadow-md transition-shadow"
      v-for="item in resumeData"
      :key="item.id"
    >
      <div>
        <div class="mb-[5px] flex items-center">
          <span class="text-[18px] text-[#000] mr-[10px]">{{ item.title }}</span>
          <!-- <div class="tag-container flex items-center">
          <el-tag size="mini" type="danger">热招</el-tag>
          <el-tag size="mini" type="info">科研</el-tag>
          <el-tag size="mini">社会招聘</el-tag>
          <el-tag size="mini" type="warning">校园招聘</el-tag>
        </div> -->
        </div>
        <p class="text-[14px] text-[#9c9c9c] mb-[5px] flex items-center">
          <span>{{ item.recruit_catagory_id }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ item.number }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>发布时间：{{ item.create_time }}</span>
        </p>
        <p class="text-[14px] text-[#9c9c9c]">
          <span>{{ item.dd }}</span>
        </p>
      </div>
      <div>
        <span class="text-[14px] mr-[15px] text-[#6b6b6b]"><i class="el-icon-document-checked"></i>已投递</span>
        <!-- <span class="text-[14px] mr-[15px] text-[#6b6b6b]"><i class="el-icon-alarm-clock"></i>审核中</span> -->
        <!-- <span class="text-[14px] mr-[15px] text-[#409EFF]"><i class="el-icon-date"></i>邀面试</span> -->
        <!-- <span class="text-[14px] mr-[15px] text-[#F56C6C]"><i class="el-icon-document-delete"></i>不匹配</span> -->
        <!-- <span class="text-[14px] mr-[15px] text-[#67C23A]"><i class="el-icon-document-checked"></i>已通过</span> -->
        <!-- <el-button>查看投递情况</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/tool';
import { resumeDelivery } from '@/api/user-center';

export default {
  name: 'AccountPositionList',
  data() {
    return {
      resumeData: [
        {
          id: '',
          title: '',
          recruit_catagory_id: '',
          dd: '',
          number: '',
          content: '',
          create_time: '',
        },
      ],
    };
  },
  mounted() {
    // 获取投递列表
    resumeDelivery().then((res) => {
      const data = res.data.rows;
      data.map((item) => {
        item.create_time = formatDate(item.create_time, 'YYYY-MM-DD');
        return item;
      });
      this.resumeData = res.data.rows;
    });
  },
};
</script>

<style lang="scss" scoped>
.tag-container .el-tag + .el-tag {
  margin-left: 10px;
}
</style>
